<section id="wire-transfer-section" class="section-card-content" data-cy="withdraw-wire-screen">
  <form>
    <!-- Copy is split at the address so the link survives each language's word order -->
    <p class="details tw-text-center tw-text-[15px] tw-text-[#0F2950] tw-mt-[95px] tw-mb-[15px]" data-cy="withdraw-wire-details">{{ 'ui.funding.withdraw.wire.contact.pre' | translate }}<a href="http://amwager.com/" class="amwager-email tw-text-[#3080EC]" data-cy="withdraw-wire-link">help&#64;amwager.com</a>{{ 'ui.funding.withdraw.wire.contact.post' | translate }}</p>

    <p class="notice tw-text-center text-font-bold tw-text-[15px] tw-text-[#0F2950] tw-mb-[90px]" data-cy="withdraw-wire-notice">
      {{ 'account.funding.wire.fee' | translate: 'A service charge of $25 will apply to wires requested under $5000.' }}
    </p>
  </form>
</section>
